import React, { use, useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { extractDate } from "../../Components/Functions/date.fun";
import { LazyImageComponent } from "../../CustomComponent/lazy_loading_image";
import { FcStackOfPhotos } from "react-icons/fc";
import { useSelector } from "react-redux";
import SimpleButton from "../../Components/layouts/simple_button";

const ViewApplication = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const [isViewed, setIsViewed] = useState(false);
  const [isShortListed, setIsShortlisted] = useState(false);
  const navigate = useNavigate();
  const [operationsRemark, setOperationsRemark] = useState("");
  const [executiveRemark, setExecutiveRemark] = useState("");
  const [ceoRemark, setCeoRemark] = useState("");
  const [salaryExpectation, setSalaryExpectation] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [notes, setNotes] = useState("");
  const [salaryError, setSalaryError] = useState("");

  const userRole = useSelector((state) => state.login);
  const role = userRole?.user?.Role;

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/career/getApplicationById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setSalaryExpectation(res.data.salaryExpectation || "");
          setJoiningDate(res.data.joiningDate || "");
          setCeoRemark(res.data.ceoRemark || "");
          setExecutiveRemark(res.data.executiveRemark || "");
          setOperationsRemark(res.data.operationsRemark || "");
          setIsShortlisted(res?.data?.isShortListed);
          setIsViewed(res.data.isViewed);
          setNotes(res.data.notes || "");
          let filter = res?.data?.actionTracking?.filter((el, i) => {
            if (el.by === userRole.user.Name && el.action === "VIEWED") {
              return el;
            }
          });
          if (filter.length > 0) {
            setIsViewed(true);
          } else {
            setIsViewed(false);
          }

          let filter1 = res?.data?.actionTracking?.filter((el, i) => {
            if (el.by === userRole.user.Name && el.action === "SHORTLISTED") {
              return el;
            }
          });
          if (filter1.length > 0) {
            setIsShortlisted(true);
          } else {
            setIsShortlisted(false);
          }
        } else {
          Toast("error", "Error while getting application!");
        }

        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handleSaveChanges = () => {
    // Implement save changes logic here

    performRequest("PATCH", "/career/update-applicant-status", {
      id,
      operationsRemark,
      executiveRemark,
      ceoRemark,
      salaryExpectation,
      notes,
      joiningDate,
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Application details updated successfully");
          navigate(`/show-applications`);
        } else {
          Toast("error", "Failed to update application details");
        }
      })
      .catch((err) => CustomErrorResponse(err));
  };
  // -------------------------
  //  UPDATE VIEWED FLAG
  // -------------------------
  const updateViewed = (checked) => {
    setIsViewed(checked); // instant UI update
    performRequest("PATCH", "/career/update-viewed", {
      id,
      isViewed: checked,
      viewedBy: userRole?.user?.Name || "NA",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Viewed status updated");
        } else {
          Toast("error", "Failed to update viewed");
        }
      })
      .catch((err) => CustomErrorResponse(err));
  };

  // -------------------------
  //  UPDATE SHORTLIST FLAG
  // -------------------------
  const updateShortlisted = (checked) => {
    setIsShortlisted(checked); // instant UI update

    performRequest("PATCH", "/career/update-shortlisted", {
      id,
      isShortListed: checked,
      shortListedBy: userRole?.user?.Name || "NA",
    })
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Shortlist status updated");
        } else {
          Toast("error", "Failed to update shortlist");
        }
      })
      .catch((err) => CustomErrorResponse(err));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcStackOfPhotos className="fs-2 me-1" />
                  Job Application
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header d-flex justify-content-between">
              <div>
                <h2 className="page-title">View Job Application</h2>
              </div>

              {role !== "client" && (
                <div className="d-flex justify-content-between">
                  <div className="me-2 d-flex justify-content-between">
                    <label htmlFor="" className="me-2">
                      Viewed
                    </label>
                    <input
                      type="checkbox"
                      id="viewed-checkbox"
                      checked={isViewed}
                      onChange={(e) => updateViewed(e.target.checked)}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    <label className="me-2">Shortlisted</label>
                    <input
                      name="isShortListed"
                      type="checkbox"
                      id="shortlist-checkbox"
                      checked={isShortListed}
                      onChange={(e) => updateShortlisted(e.target.checked)}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Name :</label>
                  <div className="w-100 col">
                    {data.Fname || data.Lname
                      ? `${data.Fname || ""} ${data.Lname || ""}`.trim()
                      : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Email :</label>
                  <div className="w-100 col">{data?.email || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Phone Number :
                  </label>
                  <div className="w-100 col">{data?.phoneNo || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Job Type :</label>
                  <div className="w-100 col">{data?.jobType || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Date :</label>
                  <div className="w-100 col">
                    {extractDate(data?.createdAt) || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Employee Type :
                  </label>
                  <div className="w-100 col">{data?.Etype || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Department :</label>
                  <div className="w-100 col">{data?.departments || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">skills :</label>
                  <div className="w-100 col">{data?.skills || "N/A"}</div>
                </div>
              )}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Resume</label>

                <div className="w-100 col">
                  {data?.uploadcv ? (
                    <>
                      {/* PDF PREVIEW */}
                      {data.uploadcv.endsWith(".pdf") ? (
                        <iframe
                          src={data.uploadcv}
                          title="Resume Preview"
                          width="100%"
                          height="500px"
                          style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                          }}
                        />
                      ) : /* IMAGE PREVIEW (jpg/png) */
                      /\.(jpg|jpeg|png)$/i.test(data.uploadcv) ? (
                        <img
                          src={data.uploadcv}
                          alt="Resume"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            borderRadius: "8px",
                            border: "1px solid #e5e7eb",
                          }}
                        />
                      ) : (
                        /* DOC / DOCX / OTHER */
                        <div>
                          <p>Preview not available</p>
                        </div>
                      )}

                      {/* ACTION BUTTONS */}
                      <div style={{ marginTop: "10px" }}>
                        <a
                          href={data.uploadcv}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-primary me-2"
                        >
                          Open Resume
                        </a>

                        <a
                          href={data.uploadcv}
                          download
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Download
                        </a>
                      </div>
                    </>
                  ) : (
                    <span className="text-muted">Resume Not Available</span>
                  )}
                </div>
              </div>

              {/* <div className="mb-3 row">
                <label className="w-25 form-label col-3">Resume</label>
                <div className="w-100 col">
                  {data?.uploadcv ? (
                    <LazyImageComponent
                      width="70%"
                      src={data?.uploadcv}
                      alt="resume photo"
                      // className="rounded"
                    />
                  ) : (
                    "Resume Not Available"
                  )}
                </div>
              </div> */}
              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">
                    Operational Remark :
                  </label>
                  <div className="col-8">
                    <textarea
                      disabled={role !== "adminStaff"}
                      value={operationsRemark}
                      onChange={(e) => setOperationsRemark(e.target.value)}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              )}

              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">
                    Executive Remark :
                  </label>
                  <div className="col-8">
                    <textarea
                      disabled={role !== "superAdmin"}
                      value={executiveRemark}
                      onChange={(e) => setExecutiveRemark(e.target.value)}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              )}

              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">CEO Remark :</label>
                  <div className="col-8">
                    <textarea
                      value={ceoRemark}
                      disabled={role !== "superAdmin"}
                      onChange={(e) => setCeoRemark(e.target.value)}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              )}

              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">Notes :</label>
                  <div className="col-8">
                    <textarea
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              )}

              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">
                    Non-Negotiable <br /> Salary Expectation :
                  </label>
                  <div className="col-3">
                    <input
                      type="text"
                      className={`form-control ${
                        salaryError ? "is-invalid" : ""
                      }`}
                      value={salaryExpectation}
                      onChange={(e) => {
                        const value = e.target.value;

                        // If empty → allow and clear error
                        if (value === "") {
                          setSalaryExpectation("");
                          setSalaryError("");
                          return;
                        }
                        // Allow only numbers (0-9)
                        if (/^\d+$/.test(value)) {
                          setSalaryExpectation(value);
                          setSalaryError("");
                        } else {
                          setSalaryError("Only numbers are allowed");
                        }
                      }}
                    />

                    {salaryError && (
                      <div className="invalid-feedback">{salaryError}</div>
                    )}
                  </div>
                </div>
              )}
              {data && role !== "client" && (
                <div className="mb-3 row align-items-center">
                  <label className="w-25 form-label col-3">
                    Joining Date :
                  </label>
                  <div className="col-3">
                    <input
                      value={joiningDate}
                      onChange={(e) => setJoiningDate(e.target.value)}
                      type="date"
                      className="form-control"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {/* <SimpleButton buttonText="Cancel" type="secondary" /> */}
                <button
                  className="btn btn-secondary mx-1 mt-2"
                  data-bs-target="#modal-report-1"
                  data-bs-toggle="modal"
                >
                  cancel
                </button>
                {role !== "client" && (
                  <button
                    // onClick={handleSaveChanges}
                    className="btn btn-primary mx-1 mt-2"
                    data-bs-target="#modal-report-1"
                    data-bs-toggle="modal"
                  >
                    Save Changes
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      {/* modal */}

      <div
        className="modal modal-blur fade modal-center"
        id="modal-report-1"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-md" role="document">
          <div
            className="modal-content"
            style={{
              borderRadius: "12px",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            <div className="modal-body">
              {"notificationData" && (
                <div>Select the relevant checkboxes before proceeding.</div>
              )}
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary me-2"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                className="btn btn-primary m-0"
                data-bs-dismiss="modal"
                // onClick={() => navigate("/show-applications")}
                onClick={handleSaveChanges}
              >
                Proceed Anyway
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewApplication;
